<template>
  <div>
    <content-header title="Additional Questions" :sub-title="subTitle" class="mb-0 mt--10"/>
    <el-form ref="form" :model="registration" :rules="rules" label-position="top" v-if="isLoaded">
      <el-row :gutter="60">
        <el-col :span="24" v-for="q in registration.additionalQs" :key="q._id">
          <div class="mt-05" v-if="q.type === 1">
            <el-input-title :required="q.required"><span v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-input class="mt-05" v-model="registration.meta[q.metaField]" placeholder="Type here..."/>
            </el-form-item>
          </div>
          <div class="mt-05" v-if="q.type === 2">
            <el-input-title :required="q.required"><span v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-select class="w-100 mt-05" v-model="registration.meta[q.metaField]" placeholder="Select" clearable>
                <el-option
                  v-for="{ value } in q.meta.options"
                  :key="value"
                  :label="value"
                  :value="value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="mt-05" v-if="q.type === 3">
            <!-- File Upload -->
            <el-input-title :required="q.required">{{ q.question || 'Your entity requires a file to be uploaded' }}</el-input-title>
            <h5 class="mt-05"><i class="el-icon-info"></i> Files must be 10mb or less</h5>
            <el-upload
              multiple
              :headers="uploadHeaders"
              :accept="accept"
              :limit="3"
              :file-list="registration.meta[q.metaField].map(file => ({ name: file.fileName }))"
              :before-upload="(file) => beforeUpload(file, q)"
              :on-error="onError"
              :on-remove="onRemove"
              action=""
              :on-change="(file) => handleChange(file, q)"
              :auto-upload="false"
            >
              <el-button class="mt-0" size="medium" type="secondary">Click to upload</el-button>
            </el-upload>
          </div>
          <!------- National Special Types ------>
          <div class="mt-05" v-if="q.type === 1001">
            <!-- NSWISA PPC Form -->
            <PPCForm :formItemProp="q.metaField | metaProp" v-model="registration.meta[q.metaField]"/>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash';
import { errormsg } from '@/utils/constants';
import { urlify } from '@/utils/helpers';
import aqsFileUploadMixin from '@/mixins/aqs-file-upload';
import PPCForm from '@/views/app/components/PPCForm.vue';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };

export default {
  name: 'AdditionalQuestions',
  props: {
    value: Object
  },
  mixins: [aqsFileUploadMixin],
  components: {
    PPCForm
  },
  data() {
    return {
      urlify,
      isLoaded: false,
      subTitle: 'The entity requires the following additional information as part of your registration',
      registration: {},
      rules: {}
    };
  },
  mounted() {
    this.isLoaded = false;
    this.registration = this.value;
    this.registration.additionalQs.sort((a, b) => a.order - b.order);
    // Regitration meta field and validation
    const hasMeta = !!this.registration.meta;
    if (!hasMeta) this.$set(this.registration, 'meta', {});

    _.forEach(this.registration.additionalQs, (q) => {
      const metaField = _.camelCase(q.fieldName);
      // eslint-disable-next-line
      q.metaField = metaField;
      if (q.required) this.$set(this.rules, `meta.${metaField}`, defaultRequiredRule);
      if (!hasMeta) {
        this.$set(
          this.registration.meta,
          metaField,
          q.type === 3 ? [] : undefined // If it's a file upload initialize an array;
        );
      }
    });

    this.isLoaded = true;
  },
  methods: {
    updateStep(step) {
      if (step === 1) {
        this.$refs.form.validate((valid) => {
          const verifyUpload = this.verifyUploads();
          if (valid && verifyUpload) {
            this.$emit('update-step', this.registration, step);
          }
        });
      } else this.$emit('update-step', this.registration, step);
    }
  },
  filters: {
    metaProp(val) {
      return `meta.${val}`;
    }
  }
};
</script>

<style scoped lang="scss">

</style>
